import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
  WorkspaceDisplayActionsEnum,
  WorkspaceDisplaySectionTrackingTypesEnum,
} from '../../../services/tracking';
import {ThunkAction} from '../../../store/appThunk';
import {hideTeammateAction} from '../../../store/data/preferences/preferencesActions';
import {WorkspaceDropReorderTeammateHandler} from '../../../store/data/workspace/reorder/types';
import {hideTeammateInAssignedTeammatesWorkspaceAsyncAction} from '../../../store/data/workspace/workspaceActions';
import {startedEditingWorkspacesAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {canDropWorkspaceItemAtTarget} from './dnd/workspaceDragDropHelpers';
import {WorkspaceDragSourceTypesEnum, WorkspaceItemDropHandler} from './dnd/workspaceDragDropTypes';
import {WorkspaceItemContainerProps, workspaceItemMapStateToProps} from './workspaceItemContainerHelpers';
import {WorkspaceTeammateItemContainerComponent} from './workspaceTeammateItemContainerComponent';

interface WorkspaceTeammateItemContainerBaseProps extends WorkspaceItemContainerProps {
  onDropReorderTeammate: WorkspaceDropReorderTeammateHandler;
}

const mapDispatchToProps = makeMapDispatchToProps<WorkspaceTeammateItemContainerBaseProps>()(({panelId}) => ({
  editWorkspaces: (hasRarelyViewedItems: boolean) => {
    trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CLICK, {
      action: WorkspaceDisplayActionsEnum.VIEW_SIDEBAR,
      section: WorkspaceDisplaySectionTrackingTypesEnum.TEAMMATES,
    });
    return startedEditingWorkspacesAction(panelId, hasRarelyViewedItems);
  },
  onHideFromWorkspace:
    (teammateId: number): ThunkAction =>
    (dispatch) => {
      dispatch(hideTeammateInAssignedTeammatesWorkspaceAsyncAction(teammateId));
      dispatch(hideTeammateAction(teammateId));
    },
}));

export const WorkspaceTeammateItemContainerBase = connect(
  workspaceItemMapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {editWorkspaces, onHideFromWorkspace} = dispatchProps;
    const {hasRarelyViewedItems} = stateProps;

    const onWorkspaceItemDrop: WorkspaceItemDropHandler = (droppedItem, linePosition, target) => {
      if (!target || !canDropWorkspaceItemAtTarget(droppedItem, target)) {
        return;
      }

      if (
        droppedItem.type !== WorkspaceDragSourceTypesEnum.ASSIGNED_TEAMMATE ||
        target.type !== WorkspaceDragSourceTypesEnum.ASSIGNED_TEAMMATE
      ) {
        return;
      }

      ownProps.onDropReorderTeammate({
        droppedItemId: droppedItem.id,
        targetItemId: target.id,
        linePosition,
      });
    };
    const onEditWorkspaces = () => {
      editWorkspaces(hasRarelyViewedItems);
    };
    return {
      ...ownProps,
      ...stateProps,
      onWorkspaceItemDrop,
      onEditWorkspaces,
      onHideFromWorkspace,
    };
  },
)(WorkspaceTeammateItemContainerComponent);
